import React from 'react';
import {Outlet} from 'react-router';

type Props = {}

export function Settings(props: Props) {
  return (
    <Outlet />
  );
}
